export class FilterModel {
  title: string;
  topic: string;
}
